import React, { useEffect } from 'react';
import './toast.scss';

const Toast = ({
	children,
	icon,
	visible = false,
	clearPopUp = () => {},
}) => {
	useEffect(() => {
		if (visible) {
			const timer = setTimeout(() => {
				clearPopUp();
			}, 2500);
			return () => clearTimeout(timer);
		}
	}, [visible, clearPopUp]);

	return (
		<div className={`status-toast-wrapper ${visible ? 'show' : 'hide'} success`}>
			{icon}
			{children}
		</div>
	);
};

export default Toast;
